<!-- TABLE TOOLBAR: CON BULK ACTIVO -->
<mat-toolbar color="accent" class="margin-align" fxFlex @fade>
  <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center" fxFill>
    <div class="toolbar-text" [attr.data-test-id-item-count]="totalItemsSelected" fxLayout="row" fxFlex>
      <span>
        {{ totalItemsSelected }} {{ (totalItemsSelected === 1 ? "COMP.ACTION_TBAR.SELECTED_SINGULAR" :
        "COMP.ACTION_TBAR.SELECTED_PLURAL") | pTranslate }} &nbsp; |
      </span>
      <button mat-button [matMenuTriggerFor]="menu" [disabled]="disabled" data-test-id="toolbar-masive-action-select">
        {{ "COMP.ACTION_TBAR.ACTIONS" | pTranslate }}
        <mat-icon class="white-icon">expand_more</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <div *ngFor="let action of actions" [matTooltip]="action.tooltip">
          <button
            mat-menu-item
            (click)="emitActionExecution(action)"
            *ngIf="!action.hidden"
            [disabled]="(isBoolean(action?.disabled)) ? action?.disabled : (action?.disabled | async)"
          >
            <img
              [id]="action.icon"
              src="assets/icons/lamp.svg"
              class="small-icon lamp_svg"
              *ngIf="action.icon === 'lamp'"
            />
            <mat-icon [id]="action.icon" *ngIf="action.icon !== 'lamp'">{{ action.icon }}</mat-icon>
            {{ action.name }}
          </button>
        </div>
      </mat-menu>
    </div>

    <button mat-icon-button>
      <mat-icon [attr.data-test-id]="'close-toolbar'" class="white-icon" (click)="emitClearSelection()">close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>
